<div class="avatar-container" [style]="avatarStyle" (click)="openAvatarUploader()">
  <div class="avatar-image-wrapper">
    <img 
      *ngIf="avatarUrl" 
      [src]="avatarUrl" 
      alt="" 
      class="avatar-image"
    />
    <div *ngIf="!avatarUrl" class="avatar-placeholder">
      <mat-icon>person</mat-icon>
    </div>
  </div>

  <div 
    *ngIf="showChangeButton" 
    class="change-photo-button" 
    (click)="openAvatarUploader()"
    [style]="buttonStyle"
    [matTooltip]="'employee.avatar.changePhoto' | translate"
    role="button"
    tabindex="0"
    (keydown.enter)="openAvatarUploader()"
    (keydown.space)="openAvatarUploader()"
  >
    <svg width="18" height="18" viewBox="0 0 24 24" focusable="false" class="camera-icon">
      <path d="M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h16v12zM12 9c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"></path>
    </svg>
  </div>
</div>
